<template>
  <div class="card modal-card-panier modal-card-border" v-if="client">
    <div class="card-content">
      <div class="subtitle is-4 has-text-centered">Modifier le client</div>
      <error-msg-component
        :messages="messages"
        :error="messages.length > 0 || champsVide.length > 0"
        :withEmplyFields="true"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        @close="resetMessages"
        title="Un problème est survenu"/>
      <b-field label="Nom commercial">
        <b-input v-model="client.nomCommercial"></b-input>
      </b-field>
      <b-field :label="$t('client.siren')">
        <b-input v-model="client.siren"></b-input>
      </b-field>
      <b-field v-if="isAffixe2" label="Application Tva" class=" mt-10">
        <b-select v-model="client.applicationTva" expanded>
          <option
            v-for="value in listeApplicationTva"
            :value="value.code"
            :key="value.code">
            {{ value.libelle }}
          </option>
        </b-select>
      </b-field>
      <adresse :adresse="client.adressePostale"></adresse>
      <footer class="mt-20">
        <div class="level">
          <div class="level-left">
            <button class="button is-gris button-modal"
                    @click="$emit('close')">
              Annuler
            </button>
          </div>
          <div class="level-right">
            <button class="button is-primary button-modal"
                    @click="modifierClient()">
              Modifier
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import adresse from '@/components/general/adresse';
import gestionErreur from '@/services/general/gestionErreur';
import { updateClient } from '@/api/clients/index';
import toastConfirmation from '@/services/general/toastConfirmation';
import genererAdresse from '@/services/general/genererAdresse';
import verifierAdresse from '@/services/client/verifierAdresse';
import { LISTE_APPLICATION_TVA } from '@/configuration/applicationTvaConf';
import translator from '@/services/client/translator';
import validationGeneral from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'modifier-client',
  components: {
    adresse,
    errorMsgComponent,
  },
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      listeApplicationTva: LISTE_APPLICATION_TVA,
    };
  },
  computed: {
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
  },
  methods: {
    resetMessages() {
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
    },
    async modifierClient() {
      this.resetMessages();
      const loadingComponent = this.$buefy.loading.open({ container: null });
      if (Object.keys(this.client.adressePostale).length > 0) {
        this.client.adressePostale = {
          ...genererAdresse(),
          ...this.client.adressePostale,
        };
        const isError = verifierAdresse(this.client.adressePostale);
        if (isError) {
          toastConfirmation('Si un champ de l\'adresse est saisi, l\'intitulé 1 et la ville doivent l\'être aussi.', 'is-danger');
          loadingComponent.close();
          return;
        }
      }
      try {
        await updateClient(this.client);
        this.$parent.close();
        this.$emit('update');
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.messages, this.champsVide,
            this.messagesChampsVide, translator);
          return;
        }
        gestionErreur('Erreur lors de la modification du client');
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/modifierClient.vue